import { CustomCell } from '../../components/custom-cell';
import { getNumericOperators } from '../../utils/getNumericOperators';
import { ToggleCell } from './components/toggle-cell';
import { getStringOperators } from '../../utils/getStringOperators';

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const TABLE_COLUMNS = () => {
	return [
		{
			headerName: '#',
			field: 'id',
			width: 100,
			minWidth: 100,
			align: 'center',
			headerAlign: 'center',
			type: 'number',
			cellClassName: 'id',
			filterOperators: getNumericOperators(),
			renderCell: params => CustomCell(params),
		},
		{
			headerName: 'Название',
			field: 'name',
			flex: 2,
			filterOperators: getStringOperators(),
			renderCell: params => CustomCell(params),
		},
		{
			headerName: 'Грузоподъемность, тн',
			field: 'weight',
			flex: 2,
			sortable: false,
			filterOperators: getNumericOperators(),
			renderCell: params => CustomCell(params),
		},
		{
			headerName: 'Вместимость, м³',
			field: 'volume',
			flex: 2,
			sortable: false,
			filterOperators: getNumericOperators(),
			renderCell: params => CustomCell(params),
		},
		{
			headerName: 'Кол-во',
			field: 'count',
			flex: 2,
			sortable: false,
			filterOperators: getNumericOperators(),
			renderCell: params => CustomCell(params),
		},
		{
			headerName: 'Доступен',
			field: 'is_allow',
			width: 150,
			sortable: false,
			filterable: false,
			// eslint-disable-next-line react/react-in-jsx-scope
			renderCell: params => <ToggleCell rowData={params.row} columnId={params.field} />,
		},
	];
};
